import React, { FC, PropsWithChildren } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Details } from '@shared/modules';

export const PaceTasksDetails: FC<RouteComponentProps> = (
  props: PropsWithChildren<RouteComponentProps>,
) => <Details {...props} headerBar={false} />;
